







































































































































































import { Component, Emit, PropSync, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import InputDatePicker from '@/components/molecules/InputDatePicker/InputDatePicker.vue'
import InputCode from '@/components/molecules/InputCode/InputCode.vue'
import { AtomTextField } from '@/components/atoms'
import { VolumeMask, VolumeNumberMask, VolumeTotalMask } from '@/types'

export interface BookbindingCollectionsFilteringConditionItem {
  bibliographySetId: {
    input: string
    errorMessage: string
  }
  volumeFrom: {
    input: string
    errorMessage: string
  }
  volumeTo: {
    input: string
    errorMessage: string
  }
  volumeNumberFrom: {
    input: string
    errorMessage: string
  }
  volumeNumberTo: {
    input: string
    errorMessage: string
  }
  volumeTotalFrom: {
    input: string
    errorMessage: string
  }
  volumeTotalTo: {
    input: string
    errorMessage: string
  }
  dateLabelFrom: {
    input: string
    errorMessage: string
  }
  dateLabelTo: {
    input: string
    errorMessage: string
  }
  holdingBranchCode: {
    input: string
    errorMessage: string
  }
}

export const defaultBookbindingCollectionsFilteringConditionItem = (): BookbindingCollectionsFilteringConditionItem => ({
  bibliographySetId: {
    input: '',
    errorMessage: ''
  },
  volumeFrom: {
    input: '',
    errorMessage: ''
  },
  volumeTo: {
    input: '',
    errorMessage: ''
  },
  volumeNumberFrom: {
    input: '',
    errorMessage: ''
  },
  volumeNumberTo: {
    input: '',
    errorMessage: ''
  },
  volumeTotalFrom: {
    input: '',
    errorMessage: ''
  },
  volumeTotalTo: {
    input: '',
    errorMessage: ''
  },
  dateLabelFrom: {
    input: '',
    errorMessage: ''
  },
  dateLabelTo: {
    input: '',
    errorMessage: ''
  },
  holdingBranchCode: {
    input: '',
    errorMessage: ''
  }
})

@Component({
  components: { InputCode, InputDatePicker }
})
export default class BookbindingCollectionsFilteringCondition extends ComponentVue {
  @Ref()
  volumeFromTextField!: AtomTextField

  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: BookbindingCollectionsFilteringConditionItem

  get volumeMask(): string {
    return VolumeMask
  }

  get volumeNumberMask(): string {
    return VolumeNumberMask
  }

  get volumeTotalMask(): string {
    return VolumeTotalMask
  }

  focusVolumeFromTextField(): void {
    this.volumeFromTextField.atomTextField.focus()
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  @Emit('keydown:enter')
  onKeydownEnter(): void {}
}
